import moment from 'moment'

var FilterMixin = {
  filters: {
    formatDate: function(date) {
      if (date != undefined) return moment.utc(date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')
    },
    formatDateTime: function(date) {
      if (date != undefined) return moment.utc(date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm')
    },
    formatBoolean: function(boolean) {
      return boolean ? 'Oui' : 'Non'
    },
    addressFormat: function(address) {
      if (address != undefined) {
        return (
          address.number +
          (address.app != undefined ? '-' + address.app : '') +
          ' ' +
          address.street +
          ' (' +
          address.city +
          ')' +
          ' ' +
          address.state +
          ' ' +
          address.postalCode +
          ', ' +
          address.regionText +
          ', ' +
          address.country
        )
      }
    },
    moneyFormat: function(value) {
      var formatter = new Intl.NumberFormat('fr-CA', {
        style: 'currency',
        currency: 'CAD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })

      return formatter.format(value)
    },
  },
}
export default FilterMixin



// WEBPACK FOOTER //
// ./src/shared/Mixin/FilterMixin.js